import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loading
    }
  }, [!_vm.loading && !_vm.dataList.length ? _c('a-empty', {
    staticClass: "mt-50",
    attrs: {
      "description": _vm.tc('暂无数据')
    }
  }) : _vm._e(), _vm._l(_vm.dataList, function (item, index) {
    return _c('a-card', {
      key: index,
      staticClass: "mb-20 mt-10",
      attrs: {
        "data-sign": "order_setting_card",
        "title": item.order_type_text
      }
    }, _vm._l(item.list, function (configure, subIndex) {
      return _c('a-row', {
        key: subIndex,
        staticClass: "order_type-box p-10"
      }, [_c('a-col', {
        attrs: {
          "span": 6
        }
      }, [_vm._v(_vm._s(configure.field_text))]), _c('a-col', {
        attrs: {
          "span": 2
        }
      }, [_c('a-switch', {
        attrs: {
          "data-sign": "order_setting_switch",
          "loading": configure._loading
        },
        on: {
          "click": function (value) {
            return _vm.handeSettingsChange(index, subIndex, value);
          }
        },
        model: {
          value: configure.field_value,
          callback: function ($$v) {
            _vm.$set(configure, "field_value", $$v);
          },
          expression: "configure.field_value"
        }
      })], 1), _c('a-col', {
        attrs: {
          "span": 16
        }
      }, [_vm._v(_vm._s(configure.field_desc))])], 1);
    }), 1);
  })], 2)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };